var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-3 _tac _px-6 _pt-9 _pb-5 _pos-r" },
    [
      _c("span", { staticClass: "gfu-quote _tc--light" }),
      _vm._v(" "),
      _vm._t("default", function () {
        return [
          _c("div", { staticClass: "gfu-bt gfu-bt--b1 _fs-i _px-6 _lh-big" }, [
            _vm._v("\n            " + _vm._s(_vm.quote) + "\n        "),
          ]),
        ]
      }),
      _vm._v(" "),
      _vm._t("author", function () {
        return [
          _c("div", {}, [
            _vm._v("\n            " + _vm._s(_vm.author) + "\n        "),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }